import React from 'react';
import PropTypes from 'prop-types';
import { PlayScoresWrapper, TeamScoresWrapper, TeamLogoWrapper } from './PlayScores.style';
import SpotTag from '@mlb/react-patterns/v4/components/SpotTag/spotTag';
import TeamLogo from '@mlb/react-patterns/v4/components/TeamLogo/teamLogo';
import Skeleton from '@mlb/react-patterns/v4/components/Skeleton/skeleton';
import { useDecoratorTranslate } from '@gameday/utils/hooks/useDecoratorTranslate';

const SEPARATOR = ',';

export const generatePlayScoresInfo = (config) => {
    const {
        isFinal,
        homeScore,
        awayScore,
        homeTeam,
        awayTeam,
        isTopInning,
        awayNameFallback,
        homeNameFallback,
        isScoringPlay = true // live feeds and summary exclud non scoring plays already without passing isScoreingPlay as props
    } = config;

    let InfoComp = <></>;
    let showcaseTeamId;
    const decoratorTranslate = useDecoratorTranslate();

    if (isFinal) {
        const homeWins = homeScore > awayScore;
        const winScore = homeWins ? homeScore : awayScore;
        const loseScore = homeWins ? awayScore : homeScore;
        const teamName = homeWins ? homeTeam.teamName : awayTeam.teamName;

        const translation = decoratorTranslate('win_final_score', '{winningTeam} win {winningTeamScore} - {losingTeamScore}', { winningTeam: teamName, winningTeamScore: winScore, losingTeamScore: loseScore });

        InfoComp = <>
            <TeamScoresWrapper>{translation}</TeamScoresWrapper>
        </>;
        showcaseTeamId = homeWins ? homeTeam.id : awayTeam.id;
    } else {
        const awayAbbr = awayTeam.abbreviation || awayNameFallback;
        const homeAbbr = homeTeam.abbreviation || homeNameFallback;

        const awaySegment = `${awayAbbr} ${awayScore}${SEPARATOR}`;
        const homeSegment = `${homeAbbr} ${homeScore}`;

        let boldAway = false;
        let boldHome = false;

        if (isScoringPlay) {
            if (isTopInning) {
                boldAway = true
            } else {
                boldHome = true;
            }
        }



        InfoComp = <>
            <TeamScoresWrapper key='away-score' scored={boldAway} >{ awaySegment }</TeamScoresWrapper>
            <TeamScoresWrapper key='home-score' scored={boldHome} >{ homeSegment }</TeamScoresWrapper>
        </>;

        showcaseTeamId = isTopInning ? awayTeam.id : homeTeam.id;
    };
    return {
        InfoComp,
        showcaseTeamId
    }
}

const PlayScores = ({
    teams = {},
    isTopInning,
    homeScore,
    awayScore,
    offset = false,
    homeNameFallback = 'Home',
    awayNameFallback = 'Away',
    isLoading = false,
    isFinal = false
}) => {
    const awayTeam = teams.away?.team || {};
    const homeTeam = teams.home?.team || {};

    const {
        InfoComp,
        showcaseTeamId
    } = generatePlayScoresInfo({
            isFinal,
            homeScore,
            awayScore,
            homeTeam: homeTeam,
            awayTeam: awayTeam,
            isTopInning,
            awayNameFallback,
            homeNameFallback,
            isScoringPlay: true
        });

    const logo = homeTeam?.sport?.id !== 1 ? <TeamLogo
        teamId={ showcaseTeamId }
        teamLogoType={ 'team' }
        width={'48px'}
        height={'48px'}
        backgroundColor={'#ECECEC'}
        rounded
    /> : <SpotTag
        id={ showcaseTeamId }
        type={'team'}
        width={'48'}
        height={'48'}
        lazyload={false}
    />;

    return (
        <PlayScoresWrapper
            $offset={ offset }
        >
            <TeamLogoWrapper
                $offset={ offset }
            >

                {!isLoading ? logo : <Skeleton width='48px' height='48px' isCircle={true}/> }
            </TeamLogoWrapper>

            {!isLoading
                ? InfoComp : <Skeleton width='114px' height='35px' margin={'0px'}/>
            }

        </PlayScoresWrapper>
    );
};

PlayScores.propTypes = {
    teams: PropTypes.object,
    isTopInning: PropTypes.bool,
    homeScore: PropTypes.number,
    awayScore: PropTypes.number,
    offset: PropTypes.bool,
    homeNameFallback: PropTypes.string,
    awayNameFallback: PropTypes.string,
    isLoading: PropTypes.bool,
    isFinal: PropTypes.bool
};

export default PlayScores;
